<template>
    <svg width="74" height="75" viewBox="0 0 74 75" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <g :clip-path="`url(#clip${id})`">
            <path d="M61.7487 12.7513C75.417 26.4196 75.417 48.5804 61.7487 62.2487C48.0803 75.9171 25.9195 75.9171 12.2512 62.2487C-1.41717 48.5804 -1.41717 26.4196 12.2512 12.7513" stroke="url(#paint0_linear)" stroke-width="2" stroke-linecap="round"/>
        </g>
        <defs>
            <linearGradient id="paint0_linear" x1="37" y1="73" x2="37" y2="7.5" gradientUnits="userSpaceOnUse">
                <stop offset="0" stop-color="#858E97"/>
                <stop offset="0.977755" stop-color="#858E97" stop-opacity="0"/>
            </linearGradient>
            <clipPath :id="`clip${id}`">
                <rect width="74" height="74" fill="#858E97" transform="translate(0 0.5)"/>
            </clipPath>
        </defs>
    </svg>

</template>

<script>
export default {
    name: 'IconLoad',

    props: {
        className: [String, Array, Object],
        id: {
            type: String,
            default: '6'
        }
    }
};
</script>

<style lang="scss">
@import "Icons";
</style>
